import operations from './operations';
import middleware from './middleware';
import accessors from './accessors';
import reducers from './reducers';

export default {
  operations,
  middleware,
  accessors,
  reducers,
};
